const fnBrowserDetect = () => {
  let agent = window.navigator.userAgent.toLowerCase()
  switch (true) {
    case agent.indexOf('edge') > -1:
      return 'MS Edge'
    case agent.indexOf('edg/') > -1:
      return 'MS Edge'
    case agent.indexOf('opr') > -1 && !!window.opr:
      return 'Opera'
    case agent.indexOf('chrome') > -1 && !!window.chrome:
      return 'Chrome'
    case agent.indexOf('trident') > -1:
      return 'MS IE'
    case agent.indexOf('firefox') > -1:
      return 'Mozilla Firefox'
    case agent.indexOf('safari') > -1:
      return 'Safari'
    default:
      return 'No browser detected'
  }
}
const DataFormater = (number) => {
  if (number < 1000 && number !== 0) {
    return parseFloat(number)?.toFixed(2) + '%'
  } else {
    if (number > 1000000000) {
      return (number / 1000000000)?.toFixed()?.toString() + 'B'
    } else if (number > 1000000) {
      return (number / 1000000)?.toFixed()?.toString() + 'M'
    } else if (number > 1000 && number < 1000000) {
      return (number / 1000)?.toFixed()?.toString() + 'K'
    } else {
      return number?.toString()
    }
  }
}
const DataFormaterGraph = (number) => {
  if (number < 1000 && number !== 0) {
    return number?.toFixed(2) + '%'
  } else {
    if (number > 1000000000) {
      return (number / 1000000000)?.toFixed()?.toString() + 'B'
    } else if (number > 1000000) {
      return (number / 1000000)?.toFixed()?.toString() + 'M'
    } else if (number > 1000) {
      return (number / 1000)?.toFixed()?.toString() + 'K'
    } else {
      return number?.toFixed()?.toString()
    }
  }
}
const NumberFormaterGraph = (number) => {
  if (number < 1000 && number !== 0) {
    return parseFloat(number)?.toFixed(2)
  } else {
    if (number > 1000000000) {
      return (number / 1000000000)?.toFixed()?.toString() + 'B'
    } else if (number > 1000000) {
      return (number / 1000000)?.toFixed()?.toString() + 'M'
    } else if (number > 1000) {
      return (number / 1000)?.toFixed()?.toString() + 'K'
    } else {
      return number?.toFixed()?.toString()
    }
  }
}
export { fnBrowserDetect, DataFormater, DataFormaterGraph, NumberFormaterGraph }
